// frontend/src/pages/legal/Terms.jsx
import React from 'react';
import LegalLayout from './LegalLayout';

const Terms = () => (
  <LegalLayout title="Terms &amp; Conditions" lastUpdated="22 September 2026">
    <h2>1. Acceptance of Terms</h2>
    <p>
      By creating an account or accessing this service, you agree to these Terms and our Privacy Policy. If you do not agree, please discontinue use immediately.
    </p>

    <h2>2. Subscriptions &amp; Billing</h2>
    <p>
      Subscriptions are self-serve and billed in advance via Stripe. You may cancel at any time; refunds are provided only as required by law. All prices are in GBP.
    </p>

    <h2>3. Fair Use &amp; Operational Access</h2>
    <p>
      You may use the live API data feeds for your own internal operational purposes. Excessive or automated scraping, reverse-engineering, or unauthorised cross-operator data access is strictly prohibited and may result in immediate account termination.
    </p>

    <h2>4. Third-Party Services</h2>
    <p>
      Our service relies on Transport for London (TfL) data feeds, which are provided on an “as is” and “as available” basis. We make no warranty regarding the accuracy, availability, or timeliness of TfL data and shall not be liable for any operational disruption.
    </p>

    <h2>5. Liability</h2>
    <p>
      To the fullest extent permitted by law, we shall not be liable for any indirect, incidental, or consequential damages arising out of or in connection with your use of the service.
    </p>
  </LegalLayout>
);

export default Terms;